module.exports = {
	"LEADING_BID_MES": "Tarjouksesi on korkein",
	"NOT_LEADING_BID_MES": "Tarjouksesi on ylitetty",
	"OBJECTS": "Esineet",
	"PROCESSING_MES": "Käynnissä",
	"VIDEO_PLAYER_MES": "Huomioithan, että videossa saattaa olla viivettä. Tarjoukset päivittyvät reaaliajassa.",
	"VIDEO_NOT_PLAYED_MES": "Tämä päätelaite ei tue videokuvan toistoa. Voit kumminkin osallistua huutokauppaan jättämällä tarjouksia kohteista",
	"NOT_LOGGED_IN_USER_MES": "Sinun tulee olla sisäänkirjautunut tehdäksesi tarjouksia.",
	"NEW_BID": "Tee uusi tarjous",
	"READ_MORE": "Lue lisää...",
	"LESS": "Sulje...",
	"LAST_LOWER_BID_MES": "Valitettavasti saman suuruinen tarjous on annettu jo aiemmin. Korotathan vielä kerran tehdäksesi korkeimman tarjouksen.",
	"START_PRICE": "Lähtöhinta",
	"HIGHEST_BID": "Korkein tarjous",
	"WON_BID": "Tarjouksesi voitti",
	"YOUR_BID": "Tarjouksesi",
	"HAMMER_PRICE": "Vasarahinta",
	"MES_WAITING_APPROVE": "Tarjouksesi odottaa vahvistamista",
	"MES_BEFORE_AUCTION": "Kuva päivittyy huutokaupan alkaessa",
	"I_AGREE_WITH": "Hyväksyn",
	"TERM": "ehdot",
	"CLOSE": "Sulje",
	"Need help?": "Tarvitsetko apua?"
};


/*****************
 ** WEBPACK FOOTER
 ** ../data/locale/fi.json
 ** module id = 25
 ** module chunks = 0
 **/